import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

export function useResendInvitation() {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (membershipId: string) =>
      apiClient.post(`api/v1/t/${tenantId}/members/${membershipId}/resend-invitation`),
  });
}
